module.exports = __webpack_public_path__ + "img/Integral1.5b3b0a6a.png";